function initCSSMarquee() {
  const pixelsPerSecond = 75;
  const marquees = document.querySelectorAll('[data-css-marquee]');

  marquees.forEach(marquee => {
    // Only clone if not already cloned
    if (!marquee.dataset.marqueeCloned) {
      marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
        const clone = list.cloneNode(true);
        clone.setAttribute('data-css-marquee-clone', 'true');
        marquee.appendChild(clone);
      });
      marquee.dataset.marqueeCloned = "true";
    }
  });

  function updateDurations() {
    marquees.forEach(marquee => {
      marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
        const duration = list.offsetWidth / pixelsPerSecond;
        list.style.animationDuration = `${duration}s`;
      });
    });
  }

  // Play when visible, pause when out of view
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const lists = entry.target.querySelectorAll('[data-css-marquee-list]');
      lists.forEach(list => {
        if (entry.isIntersecting) {
          list.style.animationPlayState = 'running';
        } else {
          list.style.animationPlayState = 'paused';
        }
      });
    });
  }, { threshold: 0 });

  marquees.forEach(marquee => {
    marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
      observer.observe(marquee);
    });
  });

  updateDurations();

  // Update durations after resize, font load, or images
  window.addEventListener('resize', updateDurations);
  if (document.fonts) {
    document.fonts.ready.then(updateDurations);
  }
  window.addEventListener('load', updateDurations);
}

document.addEventListener('DOMContentLoaded', initCSSMarquee);
